export default function Back() {
	return (
		<svg viewBox="0 0 26 12" width="26" height="12">
			{/* eslint-disable-next-line max-len */}
			<polygon fill="#010202" points="6.2,0 0,6 6.1,12 7.6,10.6 3.9,7 26,7 26,5 3.9,5 7.6,1.4" />
		</svg>
	)
}
